import React from "react";

export const PlusIcon = () => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M5 0V11M0 5.5H10" stroke="var(--gold)" strokeWidth="1.5"/>
  </svg>
);

export const MinusIcon = () => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M0 5.5H10" stroke="var(--gold)" strokeWidth="1.5"/>
  </svg>
);
